import { z } from "zod";

const patternFieldSchema = z.object({
  absenceTypeId: z.string().optional(),
  patternId: z.string(),
});

const calendarFieldSchema = z.object({
  year: z.string(),
  calendarId: z.string().nullable(),
});

export const absenceRecordsPatternsAndCalendarsFormSchema = z
  .object({
    patterns: z.array(patternFieldSchema),
    calendars: z.array(calendarFieldSchema),
  })
  .superRefine((data, ctx) => {
    data.patterns?.forEach((pattern, index) => {
      if (pattern.absenceTypeId && !pattern.patternId) {
        ctx.addIssue({
          code: "custom",
          message: "Uzupełnij dni w polu wzorzec.",
          path: ["patterns", index, "patternId"],
        });
      }
    });
  });

export type AbsenceRecordsPatternsAndCalendarsFormSchema = z.infer<
  typeof absenceRecordsPatternsAndCalendarsFormSchema
>;
